import { CSSResultGroup, html, LitElement, nothing } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { classMap } from 'lit/directives/class-map.js'
import { style } from './step.style.js'
import { hostStyle } from '@cloudsuite/mosaic-shared/styles/host.style.js'
import { initializeIconsByRole } from '@cloudsuite/mosaic-shared/icons/library.js'
import { fontStyles } from 'elements/_shared/fonts.style.js'


initializeIconsByRole({
  'cse-step.complete': { name: 'check', style: 'regular' },
})

export const stepStates = ['initial', 'active', 'completed'] as const
export type stepStatesType = typeof stepStates

export const stepVariants = ['default', 'vertical'] as const
export type stepVariantsType = typeof stepVariants

@customElement('cse-step')
export class CSEStep extends LitElement {
  static override styles: CSSResultGroup = [hostStyle, fontStyles, style]

  @property({ type: String })
  description = ''

  @property({ type: String })
  state: stepStatesType[number] = 'initial'

  @property({ type: String })
  variant: stepVariantsType[number] = 'default'

  @property({ type: String })
  url = ''

  @property({ type: String, attribute: 'aria-label' })
  override ariaLabel = ''

  private renderIcon = (completed: boolean) => {
    if (completed) {
      return html`<cse-icon size="xs" icon-role="cse-step.complete"></cse-icon>`
    }
    return nothing
  }

  override render() {
    return html`
      <div class=${classMap({
          'cse-step': true,
          [`state-${this.state}`]: true,
          [`variant-${this.variant}`]: true
        })}
        aria-current=${this.state === 'active' ? 'step' : nothing}
      >
        <a href="${this.url}" class="cse-step-circle" aria-label="${this.ariaLabel}">
          ${this.renderIcon(this.state==='completed')}
        </a>
        <div class="cse-step-content">
          <slot class="font-heading-6"></slot>
          ${this.description.length
            ? html`<div class="description font-body-s">${this.description}</div>`
            : nothing
          }
        </div>
      </div>
    `
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'cse-step': CSEStep
  }
}
